import { z } from 'zod';
export var TranscriptAPI;
(function (TranscriptAPI) {
    const contentSummarySchema = z.object({
        id: z.number(),
        generatedOn: z.date(),
        content: z.object({
            sections: z.object({
                title: z.string(),
                summary: z.string(),
            }).array(),
        }),
    });
    let GetTranscriptMetadata;
    (function (GetTranscriptMetadata) {
        GetTranscriptMetadata.RequestParamsSchema = z.object({
            transcriptId: z.coerce.number(),
        });
        GetTranscriptMetadata.ResponseBodySchema = z.object({
            metadata: z.object({
                title: z.string(),
                publishedOn: z.date(),
            }),
        });
    })(GetTranscriptMetadata = TranscriptAPI.GetTranscriptMetadata || (TranscriptAPI.GetTranscriptMetadata = {}));
    let GetTranscriptMedia;
    (function (GetTranscriptMedia) {
        GetTranscriptMedia.RequestParamsSchema = z.object({
            transcriptId: z.coerce.number(),
        });
        GetTranscriptMedia.ResponseBodySchema = z.object({
            captionsUrl: z.string().nullable(),
            url: z.string().url().nullable(),
        });
    })(GetTranscriptMedia = TranscriptAPI.GetTranscriptMedia || (TranscriptAPI.GetTranscriptMedia = {}));
    let GetTranscriptSummary;
    (function (GetTranscriptSummary) {
        GetTranscriptSummary.requestParamsSchema = z.object({
            transcriptId: z.coerce.number(),
        });
        GetTranscriptSummary.responseBodySchema = z.object({
            content: contentSummarySchema,
            items: z.unknown().array(),
        });
    })(GetTranscriptSummary = TranscriptAPI.GetTranscriptSummary || (TranscriptAPI.GetTranscriptSummary = {}));
    let GenerateTranscriptSummary;
    (function (GenerateTranscriptSummary) {
        GenerateTranscriptSummary.requestParamsSchema = z.object({
            transcriptId: z.coerce.number(),
        });
        GenerateTranscriptSummary.requestBodySchema = z.object({
            tagIds: z.coerce.number().array().default([]),
        });
    })(GenerateTranscriptSummary = TranscriptAPI.GenerateTranscriptSummary || (TranscriptAPI.GenerateTranscriptSummary = {}));
    let GetTranscriptReport;
    (function (GetTranscriptReport) {
        GetTranscriptReport.requestParamsSchema = z.object({
            transcriptId: z.coerce.number(),
        });
        GetTranscriptReport.responseBodySchema = z.object({
            key: z.string(),
        });
    })(GetTranscriptReport = TranscriptAPI.GetTranscriptReport || (TranscriptAPI.GetTranscriptReport = {}));
    let GetTranscriptEntities;
    (function (GetTranscriptEntities) {
        GetTranscriptEntities.requestParamsSchema = z.object({
            transcriptId: z.coerce.number(),
        });
        GetTranscriptEntities.responseBodySchema = z.object({
            entities: z.object({
                id: z.number(),
                value: z.string(),
                entityType: z.string(),
                occurrences: z.array(z.object({
                    start: z.number(),
                    end: z.number(),
                })),
                correctedValue: z.string().nullable(),
            }).array(),
        });
    })(GetTranscriptEntities = TranscriptAPI.GetTranscriptEntities || (TranscriptAPI.GetTranscriptEntities = {}));
})(TranscriptAPI || (TranscriptAPI = {}));
